export const GAME_WIDTH = 1280;
export const GAME_HEIGHT = 720;

export const SAVE_KEY = 'seism_save';
export const DEFAULT_PLAYER_NAME = 'Bujang Awang Tabuang';

export const SCENE_KEYS = {
  BOOT: 'BootScene',
  PRELOAD: 'PreloadScene',
  MAIN_MENU: 'MainMenuScene',
  NAME_INPUT: 'NameInputScene',
  ZONE1: 'Zone1SkyMessageScene',
  ZONE2: 'Zone2ForestSurvivalScene',
  ZONE3: 'Zone3BubunganHouseScene',
  ZONE4: 'Zone4SafeRouteScene',
  ZONE5: 'Zone5RescueScene',
  ENDING: 'EndingScene',
  ASSET_PREVIEW: 'AssetPreviewScene',
} as const;

export const ZONE_NAMES = {
  ZONE1: 'Zona 1: Pesan dari Langit',
  ZONE2: 'Zona 2: Hutan Berguncang (The Survival)',
  ZONE3: 'Zona 3: Persiapan di Rumah Bubungan Lima',
  ZONE4: 'Zona 4: Pilih Jalur Aman (The Rescue)',
  ZONE5: 'Zona 5: Aksi Sekundang Setungguan',
} as const;

export const CHARACTER_NAMES = {
  PLAYER: 'Bujang Awang Tabuang',
  NPC_ELDER: 'Kakek Sakti',
  NPC_IBUNDO: 'Ibundo Putri Rimas',
} as const;

/**
 * Skor maksimum playthrough sempurna:
 * 50 + 100 + 50 + 100 + 46 + 100 + 200 + 150 + 5 (penyelesaian misi) = 801
 */
export const SCORE_MAX_PERFECT = 801;

/** Konsep: 801–1000+ Pahlawan, 501–800 Relawan, 0–500 Warga. */
export const SCORE_TIERS = {
  HERO: { min: 801, label: 'Pahlawan Sekundang Setungguan' },
  VOLUNTEER: { min: 501, label: 'Relawan Siaga' },
  CITIZEN: { min: 0, label: 'Warga Biasa' },
} as const;

/** Batas atas tier Relawan Siaga (501–800). */
export const SCORE_TIER_VOLUNTEER_MAX = 800;

export const COLORS = {
  PRIMARY: 0x2d6a4f,
  SECONDARY: 0x40916c,
  ACCENT: 0xd4a373,
  BACKGROUND: 0x1a1a2e,
  TEXT: 0xffffff,
  TEXT_DARK: 0x1a1a2e,
  BUTTON: 0x40916c,
  BUTTON_HOVER: 0x52b788,
  OVERLAY: 0x000000,
} as const;
